import { Button as BaseButton, SxProps } from '@mui/material';

import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  onClick?: (e?: any) => void;
  type: 'primary' | 'secondary' | 'outline' | 'text';
  disabled?: boolean;
  startIcon?: ReactNode;
  sx?: SxProps;
  buttonType?: 'reset' | 'submit' | 'button';
}

export const Button: React.FC<Props> = ({
  children,
  onClick,
  type,
  startIcon,
  buttonType,
  disabled = false,
  sx = {},
}) => {
  const sxByType = {
    primary: {
      background: '#436EB2',
      border: '0.0625rem solid #436EB2',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      fontWeight: 600,
      fontFamily: 'Instrument Sans',
      color: '#FFFFFF',
      padding: '0.625rem',
      width: '100%',
      borderRadius: 0,
      '&:hover': {
        background: '#436EB2',
      },
      textTransform: 'none',
      ...sx,
    },
    secondary: {
      background: '#FCFCFC',
      border: '0.0625rem solid #ECE9DC',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      fontWeight: 600,
      fontFamily: 'Instrument Sans',
      color: '#1D1B20',
      padding: '0.625rem',
      width: '100%',
      borderRadius: 0,
      '&:hover': {
        background: '#FCFCFC',
      },
      textTransform: 'none',
      ...sx,
    },
    outline: {
      background: '#FFFFFF',
      border: '0.0625rem solid #ECE9DC',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      fontWeight: 600,
      fontFamily: 'Instrument Sans',
      color: '#1D1B20',
      padding: '0.625rem',
      width: '100%',
      borderRadius: 0,
      '&:hover': {
        background: '#FFFFFF',
      },
      textTransform: 'none',
      ...sx,
    },
    text: {
      background: '#ffffff',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      fontWeight: 600,
      fontFamily: 'Instrument Sans',
      color: '#436EB2',
      padding: '0.625rem',
      width: '100%',
      borderRadius: 0,
      textTransform: 'none',
      ...sx,
    },
  };
  return (
    <BaseButton
      startIcon={startIcon}
      onClick={onClick}
      sx={{
        ...(sxByType[type] as SxProps),
        '&.Mui-disabled': {
          background: '#A0A0A0',
          border: '0.0625rem solid #A0A0A0',
          color: '#E0E0E0',
        },
      }}
      type={buttonType}
      disabled={disabled}
    >
      {children}
    </BaseButton>
  );
};
